"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const axios_1 = __importDefault(require("axios"));
const SpinnerOverlay_1 = __importDefault(require("../components/SpinnerOverlay/SpinnerOverlay"));
const appSlice_1 = require("../store/slices/appSlice");
const store_1 = require("../store/store");
/* global window */
const TranslationsWrapper = ({ children }) => {
    const { translations } = (0, store_1.useAppSelector)((state) => state.app);
    const dispatch = (0, store_1.useAppDispatch)();
    const { data } = (0, react_query_1.useQuery)({
        queryKey: ['translations'],
        queryFn: () => axios_1.default.get('/api/translations').then((response) => response.data),
        retry: true, // Will retry failed requests until success
    });
    (0, react_1.useEffect)(() => {
        if (data) {
            dispatch((0, appSlice_1.setTranslations)(data));
            window.translations = data;
        }
        else if (translations) {
            window.translations = translations;
        }
    }, [data, dispatch, translations]);
    const hasTranslations = data && translations;
    return ((0, jsx_runtime_1.jsx)(SpinnerOverlay_1.default, { visible: !hasTranslations, allWhiteBackground: true, children: hasTranslations ? children : null }));
};
exports.default = TranslationsWrapper;
